import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ConsentFormDialog from './ConsentFormDialog'
// import { history } from "../../../index"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom'
import * as Actions from "../../../store/actions"
import { useParams, useLocation } from "react-router-dom"
import MeetingScreen from '../../../pages/meetingScreen/MeetingScreen'
import { isTablet, isIOS, isSafari, isAndroid } from 'react-device-detect'
import EndingMeetingDialog from '../meetingScreen/EndingMeetingDialog'
// import { Button } from 'reactstrap'
import Alert from '../../../utils/common/alert'
import Axios from 'axios'
import Webcam from "react-webcam";
import {
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Fab
} from "@material-ui/core"
import { VERSION_NO } from '../../../store/actions'
// const isIOS = true;
const AndroidApp = "https://play.google.com/store/apps/details?id=com.bluejay.telehealth"
const IOSApp = "https://apps.apple.com/us/app/bluejay-engage-patient/id1527839713"



const JoinMeetingBody = props => {



    const { search } = useLocation()

    const query = new URLSearchParams(search);

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const isAuth2 = useSelector(({ auth }) => auth.isAuth);



    let centered = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "inline-flex",
        width: "25rem",
        height: "25rem",
        opacity: "0.9"
    }
    // let {origin} = window.location;

    function handleSubmit() {
        let textArea;
        textArea = document.createElement('textArea');
        textArea.value = id;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        Alert("Meeting ID copied to clipboard.");
    }
    const query2 = new URLSearchParams(location.search)



    if (isIOS && !query2.has("autoLogin") && !isAuth2) {
        return (
            (
                <div className="forIosSafari">
                    <div
                        // style={{ background: "url('/images/background.jpg')" }}
                        className="card shadow-sm p-3 mb-5 rounded "
                        style={{
                            ...centered,
                            width: "26rem",
                            height: "20rem",
                        }} align="center">
                        <div className="text-center">
                            <img
                                style={{ width: "15rem" }}
                                src="/images/ptlogo.png"
                                alt="Card image cap"
                            />
                        </div>
                        <div className="card-body" style={{ flex: "none", padding: "0.30rem 1rem" }}>
                            <p className="card-text" style={{ color: "black" }}>
                                Please copy the meeting ID from below and use it in our IOS meeting app!</p>
                            <p id={"link"} style={{ display: "inline-block", flexDirection: "column" }}>
                                Meeting ID : {id}
                                <div className="copy-conIlsa">
                                    <h2 className="heading-link"
                                        onClick={handleSubmit}
                                    >
                                    </h2>

                                    <span
                                        onClick={handleSubmit}
                                        className="copydiv">
                                        <img
                                            className="copy-img"
                                            src="/images/copy clip.png"
                                        />
                                        <h2 className="copy-heading">
                                            copy
                                        </h2>
                                    </span>
                                </div>
                            </p>

                        </div>
                        <div className="card-body" style={{ flex: "none", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                            <p style={{ marginTop: "0px" }} id={"asim"}>Don't have our app?</p>
                            <a href={IOSApp} target="blank">
                                <button
                                    style={{ width: "20rem", height: "3rem", opacity: "1", }}
                                    className="btn btn-primary" onClick={handleSubmit}>
                                    Download it from App store
                                </button>
                            </a>
                        </div>
                    </div>

                </div>
            )
        )
    }

    if (isAndroid && !query2.has("autoLogin") && !isAuth2) {
        return (
            (
                <div className="forIosSafari">
                    <div
                        className="card shadow-sm p-3 mb-5 rounded "
                        style={{
                            ...centered,
                            width: "26rem",
                            height: "20rem",
                        }} align="center">
                        <div className="text-center">
                            <img
                                style={{ width: "15rem" }}
                                src="/images/ptlogo.png"
                                alt="Card image cap"
                            />
                        </div>
                        <div className="card-body" style={{ flex: "none", padding: "0.30rem 1rem" }}>
                            <p className="card-text" style={{ color: "black" }}>
                                Please copy the meeting ID from below and use it in our Android meeting app!</p>
                            <p id={"link"} style={{ display: "inline-block", flexDirection: "column" }}>
                                Meeting ID : {id}
                                <div className="copy-conIlsa">
                                    <h2 className="heading-link"
                                        onClick={handleSubmit}
                                    >
                                    </h2>

                                    <span
                                        onClick={handleSubmit}
                                        className="copydiv">
                                        <img
                                            className="copy-img"
                                            src="/images/copy clip.png"
                                        />
                                        <h2 className="copy-heading">
                                            copy
                                        </h2>
                                    </span>
                                </div>
                            </p>

                        </div>
                        <div className="card-body" style={{ flex: "none", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                            <p style={{ marginTop: "0px" }} id={"asim"}>Don't have our app?</p>
                            <a href={AndroidApp} target="blank">
                                <button
                                    style={{ width: "20rem", height: "3rem", opacity: "1", }}
                                    className="btn btn-primary" onClick={handleSubmit}>
                                    Download it from Play store
                                </button>
                            </a>
                        </div>
                    </div>

                </div>
            )
        )
    }

    const [IsAudioOn, setIsAudioOn] = useState(true)
    const [IsVideoOn, setIsVideoOn] = useState(true)

    const [Selected, setSelected] = useState(null)
    const [Name, setName] = useState("")
    const [IsUrl, setIsUrl] = useState(false)
    const [EndMeetingDialog, setEndMeetingDialog] = useState(false)
    const [AgreeButtonClick, setAgreeButtonClick] = useState(false)
    const [ModelOpen, setModelOpen] = useState(false)
    const [Loading, setLoading] = useState(true)
    const [ErrorMsg, setErrorMsg] = useState("")
    const [Verified, setVerified] = useState(false)
    const [RoomData, setRoomData] = useState(null)
    const [IsOnline, setIsOnline] = useState(false)
    const [MeetingHasStarted, setMeetingHasStarted] = useState(false)
    const [MsgForErrorBig, setMsgForErrorBig] = useState("")
    // const [IsMeeting, setIsMeeting] = useState(false)
    const IsMeeting = useSelector(({ meeting }) => meeting.MeetingOn)
    const isAuth = useSelector(({ auth }) => auth.isAuth);
    const VerifyData = useSelector(({ auth }) => auth.VerifyData);
    const baseURL = useSelector(({ utils }) => utils.baseURL);

    useEffect(() => {
        if (IsMeeting) {
            setMeetingHasStarted(true)
        }
        if (!IsMeeting && MeetingHasStarted) {

            setEndMeetingDialog(true)
        }
    }, [IsMeeting])

    useEffect(() => {
        // if(!VerifyData) return
        const query = new URLSearchParams(location.search)

        RedirectToApp(query)

        if (query.get("userType") == "Patient") {
            setIsUrl(true)
            setName(query.get("userName") || "Patient")
            setTimeout(() => {
                setSelected(1);
            }, 500);
            // console.log(VerifyData.isSNFMeeting,"VerifyData")
            if (VerifyData) {
                if(VerifyData?.status != 1) return
                if (VerifyData?.isSNFMeeting == 0) {
                    // alert("Aim")
                    setModelOpen(true)
                } else {

                    if (VerifyData?.disableSNFConsent == 1) {
                        setAgreeButtonClick(true)
                        // alert("asim")
                        SetPatiendStatus()
                    } else {
                        setModelOpen(true)
                    }

                }
            }
        }
    }, [Loading])

    let myTime;


    useEffect(() => {
        setTimeout(() => {
            CheckVerification()
        }, 500);

        return () => clearInterval(myTime);
    }, [])

    useEffect(() => {
        setAgreeButtonClick(false)
        setModelOpen(false)
    }, [IsMeeting])


    useEffect(() => {
        if (!ModelOpen && !AgreeButtonClick) {
            setSelected(null)
        }
    }, [ModelOpen])
    useEffect(() => {
        if (IsOnline && AgreeButtonClick) {
            // console.log("Starting Meeting")
            JoinMeeting()
        }
    }, [IsOnline, AgreeButtonClick])

    function SetPatiendStatus() {
        if (IsOnline) return

        Axios.post(baseURL + `/PT2/httpdocs/${VERSION_NO}/sendPatientInWaitingRoomOnVC`, {
            "userNDme": Name || "",
            "userType": "patient",
            "hostId": VerifyData?.hostId,
            "groupVideoRoomId": VerifyData?.groupVideoRoomId,
            "token": VerifyData?.uniqueSessionId
        });
    }

    function RedirectToApp(query) {

        if (query.get("token")) {
            // if (true) {
            let isMobileDevice = false;
            if (/iPhone|Android/i.test(navigator.userAgent)) {
                isMobileDevice = true;
            }

            if (isMobileDevice) {
                // if (true) {
                let userAgent2 = navigator.userAgent.toLowerCase();
                const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent2);

                // if (true) {
                if (!isTablet) {
                    const isAndroid = /Android/i.test(navigator.userAgent);

                    // if (!isAndroid) return window.location.href = IOSApp;
                    return
                    //  window.location.href = AndroidApp
                }
            }
        }
    }

    function CheckRoomStatus() {
        if (IsMeeting) return
        dispatch(Actions.CheckRoomStatus(id)).then((res) => setIsOnline(res))
    }

    function CheckVerification() {
        let toLogin = 0;
        let doctorID = 0;
        let pmID = 0
        const query = new URLSearchParams(location.search)

        if (query.has("autoLogin")) {
            toLogin = 1;
            doctorID = query.get("participateId")
            pmID = query.get("pmid")
        }
        dispatch(Actions.VerifyRoomNumber(id, toLogin, doctorID, pmID, false, navigate)).then((res) => {
            if (!res.status) {
                setVerified(false)
                setLoading(false)
                setMsgForErrorBig(res.data.msg)
            }
            if (res.status) {
                myTime = setInterval(() => {

                    if (IsMeeting) {
                        clearInterval(myTime)
                    }
                    CheckRoomStatus()

                }, 5000);


                setVerified(true)
                setRoomData(res.data);
                setLoading(false)
            }
        })
    }
const participantId = query.get("userId")

    function JoinMeeting() {
        if (!Name) return setErrorMsg("Please enter a name!")
        if (Selected == null) return setErrorMsg("Please select who you are");

        // if (Selected === 1 && !ModelOpen) return setErrorMsg("Please accept the concent form to join meeting as patient!")
        setErrorMsg("")

        const Who = Selected == 1 ? "Patient" : Selected == 2 ? "Caregiver" : Selected == 3 ? "Provider" : Selected == 4 ? "Other" : "";
        dispatch({
            type: Actions.SETTING_MEETING_ON,
            payload: true,
        })
        sessionStorage.setItem("DefaultSettings", JSON.stringify({ IsAudioOn, IsVideoOn }))
        dispatch(Actions.CreatingRoom(id, Name, Who, true, IsUrl, IsAudioOn, IsVideoOn, participantId))
        // clearTimeout(myTime);
        clearInterval(myTime)
        // setIsMeeting(true)

    }
    // console.log("IsMeeting Global", IsMeeting)
    if (IsMeeting || isAuth) {
        return <MeetingScreen />
    }


    return (
        <section className="newJoinBody">
            <img
                className="new-join-logo-img"
                style={{ maxHeight: "60px" }}
                src={VerifyData?.clinicLogo ? VerifyData.clinicLogo : "/images/ptlogo.png"}
            />
            {
                Loading ? (
                    <div className="myContainer">
                        <img src="/images/loaderblue.gif" style={{ height: "200px", width: "auto" }} />
                    </div>
                ) : (
                    <>
                        <div className="myContainer">
                            {
                                Verified ? (
                                    <>
                                        <div className="leftJ">
                                            <div style={{ minWidth: "90%", minHeight: "90%", maxHeight: "90%", overflow: "hidden", position: "relative", display: "flex", justifyContent: "center", alignItems: "flex-end", backgroundImage: !IsVideoOn ? "url(/images/avatarpic.png)" : "", backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                                                {/* <Webcam style={{ maxWidth: "100%" }} /> */}
                                                {
                                                    IsVideoOn ? <Webcam mirrored audio={false} style={{ maxWidth: "100%" }} /> : null
                                                }

                                                <Fab
                                                    className="leftFab"
                                                    onClick={() => setIsAudioOn(!IsAudioOn)}
                                                    style={{ position: "absolute", background: IsAudioOn ? "white" : "#2570b7", bottom: "20px", left: "40%" }}>
                                                    <img src={`/images/newIcons/${IsAudioOn ? "mute.svg" : "unmute.svg"}`} />
                                                </Fab>
                                                <Fab
                                                    className="rightFab"
                                                    onClick={() => setIsVideoOn(!IsVideoOn)}
                                                    style={{ position: "absolute", background: IsVideoOn ? "white" : "#2570b7", bottom: "20px", right: "40%" }}>
                                                    <img src={`/images/newIcons/${IsVideoOn ? "video-camera.svg" : "video-camera-off.svg"}`} />
                                                </Fab>
                                            </div>
                                        </div>
                                        <div className="leftR">
                                            <span style={{ fontWeight: "bold" }}>
                                                Meeting ID: <span style={{ color: "#2570b7" }}>{id}</span>  <img title="Copy"
                                                    onClick={async (e) => {
                                                        await navigator.clipboard.writeText(`${window.location.href}`)
                                                        Alert(`${window.location.href}`, 'success', 'Link copied to clipboard.')
                                                    }}
                                                    style={{ cursor: "pointer", height: "16px", marginTop: "-4px" }} src="/images/icons/copy.svg" />
                                            </span>
                                            {/* <span style={{ color: IsOnline ? "green" : "red", marginTop: "30px" }}>{IsOnline ? "Online" : "Offline"} </span> */}
                                            <TextField
                                                InputLabelProps={{ style: { fontStyle: "italic" } }}
                                                disabled={AgreeButtonClick}
                                                className="specialInput"
                                                variant="standard"
                                                label="Enter your name"
                                                style={{ width: "80%", marginTop: "30px" }}
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                            <FormControl style={{ width: "80%", marginTop: "30px" }} >
                                                <InputLabel style={{ fontStyle: "italic" }} id="demo-simple-select-label">Select one</InputLabel>
                                                <Select
                                                    disabled={AgreeButtonClick}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={Selected}
                                                    onChange={(e) => {
                                                        if (e.target.value === 1) {
                                                            if (VerifyData.isSNFMeeting == 1) {
                                                                setSelected(1)
                                                                // console.log()
                                                                SetPatiendStatus()
                                                                return
                                                            }
                                                            if (!Name) return setErrorMsg("Please enter a name before selecting!")
                                                            setSelected(1)
                                                            // if (setSelected != 1) {
                                                            setModelOpen(true)
                                                            setErrorMsg("")
                                                        } else {
                                                            setSelected(e.target.value)

                                                        }
                                                    }}
                                                >
                                                    <MenuItem value={1}>I am a Patient.</MenuItem>
                                                    <MenuItem value={2}>I am a Caregiver.</MenuItem>
                                                    <MenuItem value={3}>I am a Provider.</MenuItem>
                                                    <MenuItem value={4}>Other.</MenuItem>
                                                </Select>
                                                <p style={{ color: "red", marginTop: "20px" }}> {ErrorMsg} </p>
                                            </FormControl>
                                            {
                                                AgreeButtonClick ? (
                                                    <>
                                                        {
                                                            RoomData?.presenterName ? "Waiting for the host to start this meeting" : MsgForErrorBig || "This room number is already expired!"
                                                        }
                                                    </>
                                                ) : (
                                                    <>

                                                        {
                                                            IsOnline ? <Button
                                                                className="Special2"
                                                                disabled={!IsOnline}
                                                                onClick={() => JoinMeeting()}
                                                                style={{ backgroundColor: IsOnline ? "#ff9e16" : "grey", color: "white", alignSelf: "flex-end", marginRight: "10%", minWidth: "100px", marginTop: "30px" }}
                                                                variant="contained">
                                                                Join
                                                            </Button> : "waiting for the host to start the meeting!"
                                                        }

                                                    </>
                                                )
                                            }

                                        </div>


                                    </>
                                ) : (
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <h1>
                                            {MsgForErrorBig}
                                        </h1>
                                        {
                                            new URLSearchParams(location.search).get("userType") == "Patient" ? null : (
                                                <>
                                                    <Button
                                                        onClick={() => navigate("/")}
                                                        style={{ backgroundColor: "#ff9e16", color: "white", width: "200px", marginTop: "30px" }}
                                                        variant="contained">
                                                        Go to login page
                                                    </Button>
                                                </>
                                            )
                                        }

                                    </div>
                                )
                            }
                        </div>

                    </>
                )
            }
            {
                ModelOpen ? (
                    <ConsentFormDialog
                        clickAgress={() => setAgreeButtonClick(true)}
                        onDisagree={() => setSelected(4)}
                        formUrl={RoomData?.clinicConsent}
                        isOpen={ModelOpen}
                        close={() => setModelOpen(false)}
                        name={Name}
                        isLive={IsOnline}
                        JoinMeeting={() => JoinMeeting()}
                    />
                ) : null
            }

            {
                EndMeetingDialog ? (
                    <EndingMeetingDialog
                        close={() => {
                            setEndMeetingDialog(false)
                            if (VerifyData.clinicWebsite) {
                                // window.location.href = "https://www.bluejayhealth.com"
                                if (VerifyData.clinicWebsite.substring(0, 7) == 'http://' || VerifyData.clinicWebsite.substring(0, 8) == 'https://') {
                                    window.location.href = VerifyData.clinicWebsite
                                } else {
                                    window.location.href = "https://" + VerifyData.clinicWebsite
                                }
                            } else {
                                window.location.href = "https://www.bluejayhealth.com"
                            }
                        }}
                        isOpen={EndMeetingDialog}
                    />
                ) : null
            }
        </section>
    )

}

JoinMeetingBody.propTypes = {

}

export default JoinMeetingBody




// return (
//     <section className="index-join">
//         <img
//             className="join-logo-img"
//             style={{ maxHeight: "50px" }}
//             src={VerifyData?.clinicLogo ? VerifyData.clinicLogo : "/images/ptlogo.png"}
//         />
//         <section className="joinBox">


//             {
//                 Loading ? (
//                     <img src="/images/loaderblue.gif" style={{ height: "100%", width: "100%" }} />
//                 ) : (
//                     <>
//                         {
//                             AgreeButtonClick ? (
//                                 <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
//                                     {
//                                         RoomData?.presenterName ? (
//                                             <>
//                                                 <p style={{ fontSize: "25px", textAlign: "center" }}>
//                                                     Waiting for the host to start this meeting
//                                                 </p>
//                                                 <p style={{ fontSize: "25px", textAlign: "center" }}>
//                                                     {`${RoomData?.presenterName}'s Meeting`}
//                                                 </p>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <p style={{ fontSize: "25px", textAlign: "center" }}>
//                                                     {
//                                                         MsgForErrorBig || "This room number is already expired!"
//                                                     }
//                                                 </p>
//                                             </>
//                                         )
//                                     }
//                                 </div>
//                             ) : (

//                                 <>
//                                     {
//                                         Verified ? (
//                                             <>
//                                                 <h2 className="telecall-h2">
//                                                     Telehealth call with {RoomData?.presenterName} <span style={{ color: IsOnline ? "green" : "red" }}>({IsOnline ? "Online" : "Offline"}) </span>
//                                                 </h2>

//                                                 <h2 className="enterName-join-h2">
//                                                     ENTER YOUR NAME
//                                                 </h2>

//                                                 <input
//                                                     maxLength={"31"}
//                                                     value={Name}
//                                                     onChange={(e) => setName(e.target.value)}
//                                                     className="enter-name-input"
//                                                 />

//                                                 <h2 className="are-patient-h2">
//                                                     ARE YOU A PATIENT?
//                                                 </h2>

//                                                 <div className="wrapper">
//                                                     <input type="radio" id="optn2" checked={Selected === 1} onChange={() => {
//                                                         if (VerifyData.isSNFMeeting == 1) {
//                                                             setSelected(1)
//                                                             SetPatiendStatus()
//                                                             return
//                                                         }
//                                                         if (!Name) return setErrorMsg("Please enter a name!")
//                                                         setSelected(1)
//                                                         // if (setSelected != 1) {
//                                                         setModelOpen(true)


//                                                         setErrorMsg("")
//                                                         // }
//                                                     }} />
//                                                     <label className="label-check" htmlFor="optn2">I am a Patient.</label>
//                                                 </div>
//                                                 <div className="wrapper">
//                                                     <input type="radio" id="optn3" checked={Selected === 2} onChange={() => setSelected(2)} />
//                                                     <label className="label-check" htmlFor="optn3">I am a Caregiver.</label>
//                                                 </div>
//                                                 <div className="wrapper">
//                                                     <input type="radio" id="optn4" checked={Selected === 3} onChange={() => setSelected(3)} />
//                                                     <label className="label-check" htmlFor="optn4">I am a Provider.</label>
//                                                 </div>
//                                                 <div className="wrapper">
//                                                     <input type="radio" id="optn5" checked={Selected === 4} onChange={() => setSelected(4)} />
//                                                     <label className="label-check" htmlFor="optn5">Other.</label>
//                                                 </div>
//                                                 <h5 style={{ textAlign: "center", color: "red" }}>{ErrorMsg} </h5>
//                                                 <button disabled={!IsOnline} onClick={() => JoinMeeting()} style={{ background: IsOnline ? "" : "grey" }} id="enter" className="btn-join">
//                                                     {
//                                                         IsOnline ? "JOIN MEETING" : "waiting for the host to start the meeting!"
//                                                     }
//                                                 </button>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <div style={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", }}>
//                                                     <h3 style={{ marginBottom: "50px", textAlign: "center" }}>
//                                                         {MsgForErrorBig}
//                                                     </h3>
//                                                     <button onClick={() => history.push("/")} id="enter" className="btn-join">
//                                                         Go to Login
//                                                     </button>
//                                                 </div>
//                                             </>
//                                         )
//                                     }

//                                 </>

//                             )
//                         }
//                     </>
//                 )
//             }

//         </section>


//     </section>
// )